class AssortedProduct extends HTMLElement {
  constructor() {
    super();

    this.$productForm = this.querySelector('product-form');
    this.$footer = this.querySelector('footer');
    this.buttons = this.querySelectorAll('button[name="variant"]');
    this.images = this.querySelectorAll('[id^="assorted-product-image"]');

    if (!this.buttons && !this.$productForm) {
      return;
    }

    this.buttons.forEach(($button) => {
      $button.addEventListener('click', (event) => this.handleClick(event));
    });
  }

  handleClick({ target }) {
    this.buttons.forEach(($b) => $b.setAttribute('aria-current', 'false'));
    target.setAttribute('aria-current', 'true');

    const { variantId, variantAvailable } = target.dataset;
    const $input = this.$productForm.querySelector('input[name="id"]');
    const $button = this.$productForm.querySelector('button[name="add"]');
    const imageId = target.getAttribute('aria-controls')?.trim().split(' ')[0] || '';

    if (variantAvailable === 'false') {
      $input.disabled = true;
      $button.disabled = true;
      this.$footer.disabled = true;
    } else {
      $input.removeAttribute('disabled');
      $button.removeAttribute('disabled');
      this.$footer.removeAttribute('disabled ');
    }

    if (imageId && this.images) {
      this.images.forEach(($image) => $image.setAttribute('aria-hidden', 'true'));
      console.log(this.querySelector(`img[id="${imageId}"]`));
      this.querySelector(`img[id="${imageId}"]`).setAttribute('aria-hidden', 'false');
    }

    $input.value = variantId;
  }
}

customElements.define('assorted-product', AssortedProduct);
